/* eslint-disable no-else-return */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory, withRouter } from 'react-router-dom';
import { History } from 'history';
import style from './OperationsMenuMobile.module.css';
import {
  setDisconnectFromMasterConfirmationStatus,
  setLanguagesMenuStatus,
  setOpsMenuStatus
} from '../../../redux/actions/setMobileMenusStatus';
import { PAMMState } from '../../../redux/reducers/rootReducer';
import { AccountType } from '../../../types/authTypes';
import LocalStorageUtils from '../../../utils/local-storage';
import { Investor } from '../../../types/investorTypes';
import { useUser } from '../../../utils/useUser';
import { applyStyles } from '../../../utils/applyStyles';
import { ReactComponent as AutoDisIcon } from '../../../icons/mobileMenuIcons/autoDisconnect.svg';
import { ReactComponent as CommissionsIcon } from '../../../icons/mobileMenuIcons/commissions.svg';
import { ReactComponent as CreditInOutIcon } from '../../../icons/mobileMenuIcons/creditInOut.svg';
import { ReactComponent as DepositWithdrawalIcon } from '../../../icons/mobileMenuIcons/depositWithdrawal.svg';
import { ReactComponent as DisconnectIcon } from '../../../icons/mobileMenuIcons/disconnect.svg';
import { ReactComponent as HistoryIcon } from '../../../icons/mobileMenuIcons/history.svg';
import { ReactComponent as LanguageIcon } from '../../../icons/mobileMenuIcons/language.svg';
import { ReactComponent as StatementIcon } from '../../../icons/mobileMenuIcons/statement.svg';
import { ReactComponent as ConnectedInvIcon } from '../../../icons/mobileMenuIcons/connectedInvestors.svg';
import { ReactComponent as LogouotIcon } from '../../../icons/mobileMenuIcons/logout.svg';
import { logoutUserAsync } from '../../../redux/actions/auth';
import { FundsType } from '../../../types/masterTypes';

const OperationsMenuMobile: React.FC<any> = ({ onSwipe, onCancel, location, currentLang }): JSX.Element => {
  const dispatch = useDispatch();
  const history: History = useHistory();
  const api: string = useSelector((state: PAMMState) => state.configReducer.api);

  const languages: Record<string, string> = useSelector((state: PAMMState) => state.configReducer.languages);
  const investor: Investor = useSelector((state: PAMMState) => state.investorReducer.investor);
  const fundsType = useSelector((state: PAMMState) => state.masterReducer.chosenFundsType);

  const show = useSelector((state: PAMMState) => state.mobileMenusStatusReducer.showOpsMenu);

  const user = useUser();

  const linkedId = LocalStorageUtils.getValueFromLocalStorage('linkedIdMobile') || user?.Id;

  const showDisconnectFromThisMasterWarning =
    investor.MasterId !== 0 && user?.AccountInfo?.AccountOptions?.DetachAction !== 'Off';

  React.useEffect(() => {
    dispatch(setOpsMenuStatus(false));
  }, [dispatch, location]);

  const handleShowLanguagesMenu = (): void => {
    dispatch(setOpsMenuStatus(false));
    dispatch(setLanguagesMenuStatus(true));
  };

  const handleDetachInvestor = (): void => {
    dispatch(setDisconnectFromMasterConfirmationStatus(true));
    dispatch(setOpsMenuStatus(false));
  };

  const handleLogout = (): void => {
    dispatch(setOpsMenuStatus(false));
    dispatch(logoutUserAsync(api, history));
  };

  const getNeededAccountId = () => {
    if (user?.AccountType === AccountType.Master && fundsType === FundsType.TotalFunds) {
      return user?.Id;
    } else {
      return linkedId;
    }
  };

  const showBalanceActions =
    (user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.InvestorWithdrawButton === 'Show') ||
    (user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.InvestorCreditButton === 'Show');

  const showRiskManagement =
    (user?.AccountType === AccountType.Investor && showDisconnectFromThisMasterWarning) ||
    (user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.ChangeSlTpButton === 'Show');

  return (
    <div
      id="operations-menu"
      className={applyStyles([style['menu'], show ? style['show'] : style['hide']])}
      onPointerMove={(event) => onSwipe(event)}
      onPointerCancel={() => onCancel('operationsMenu')}
    >
      {showBalanceActions ? (
        <section>
          <div className={applyStyles([style['title'], 'text-h4-semibold'])}>
            <FormattedMessage id="balanceActions" />
          </div>

          {/* INVESTOR: Deposit or Deposit/Withdrawal */}
          {user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.InvestorWithdrawButton === 'Show' ? (
            <Link to={`/change-balance/${getNeededAccountId()}`}>
              <div className={style['row']}>
                <span className={style['icon']}>
                  <DepositWithdrawalIcon />
                </span>
                <span className={applyStyles([style['link'], 'text-h4'])}>
                  <FormattedMessage id="operations.depositWithdrawal" />
                </span>
              </div>
            </Link>
          ) : null}

          {/* INVESTOR: Credit In/Out */}
          {user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.InvestorCreditButton === 'Show' ? (
            <Link to={`/change-credit/${getNeededAccountId()}`}>
              <div className={style['row']}>
                <span className={style['icon']}>
                  <CreditInOutIcon />
                </span>
                <span className={applyStyles([style['link'], 'text-h4'])}>
                  <FormattedMessage id="operations.creditInOut" />
                </span>
              </div>
            </Link>
          ) : null}
        </section>
      ) : null}

      {showRiskManagement ? (
        <section>
          <div className={applyStyles([style['title'], 'text-h4-semibold'])}>
            <FormattedMessage id="riskManagement" />
          </div>

          {/* INVESTOR: DISCONNECT */}
          {user?.AccountType === AccountType.Investor && showDisconnectFromThisMasterWarning ? (
            <Link to="/#" onClick={handleDetachInvestor}>
              <div className={style['row']}>
                <span className={style['icon']}>
                  <DisconnectIcon />
                </span>
                <span className={applyStyles([style['link'], 'text-h4'])}>
                  <FormattedMessage id="button.disconnect" />
                </span>
              </div>
            </Link>
          ) : null}

          {/* INVESTOR: AUTO DISCONNECT */}
          {user?.AccountType === AccountType.Investor && user?.AccountInfo?.AccountOptions?.ChangeSlTpButton === 'Show' ? (
            <Link to={`/edit-slTp/${investor.Id}`}>
              <div className={style['row']}>
                <span className={style['icon']}>
                  <AutoDisIcon />
                </span>
                <span className={applyStyles([style['link'], 'text-h4'])}>
                  <FormattedMessage id="button.autoDisconnect" />
                </span>
              </div>
            </Link>
          ) : null}
        </section>
      ) : null}

      <section>
        <div className={applyStyles([style['title'], 'text-h4-semibold'])}>
          <FormattedMessage id="information" />
        </div>

        {/* MASTER and INVESTOR: Orders Commissions */}
        <Link to={`/commissions/${getNeededAccountId()}`}>
          <div className={style['row']}>
            <span className={style['icon']}>
              <CommissionsIcon />
            </span>
            <span className={applyStyles([style['link'], 'text-h4'])}>
              <FormattedMessage id="operations.commissions" />
            </span>
          </div>
        </Link>

        {/* MASTER: Connected Investors */}
        {user?.AccountType === AccountType.Master && user?.AccountInfo?.AccountOptions?.MmConnectedInvestors === 'Show' ? (
          <Link to="/investors">
            <div className={style['row']}>
              <span className={style['icon']}>
                <ConnectedInvIcon />
              </span>
              <span className={applyStyles([style['link'], 'text-h4'])}>
                <FormattedMessage id="operations.connectedInvestors" />
              </span>
            </div>
          </Link>
        ) : null}

        {/* History: Always show for INVESTOR and MASTER */}
        <Link to={`/history/${getNeededAccountId()}`}>
          <div className={style['row']}>
            <span className={style['icon']}>
              <HistoryIcon />
            </span>
            <span className={applyStyles([style['link'], 'text-h4'])}>
              <FormattedMessage id="operations.history" />
            </span>
          </div>
        </Link>

        {/* Statements: Condition for INVESTOR, but always show for MASTER */}
        {user?.AccountInfo?.AccountOptions?.InvestorStatementButton === 'Show' || user?.AccountType === AccountType.Master ? (
          <Link to={`/download-statement/${getNeededAccountId()}`}>
            <div className={style['row']}>
              <span className={style['icon']}>
                <StatementIcon />
              </span>
              <span className={applyStyles([style['link'], 'text-h4'])}>
                <FormattedMessage id="operations.statements" />
              </span>
            </div>
          </Link>
        ) : null}
      </section>

      <section>
        <div className={applyStyles([style['title'], 'text-h4-semibold'])}>
          <FormattedMessage id="other" />
        </div>

        <button className={applyStyles([style['row'], 'text-h4'])} onClick={handleShowLanguagesMenu} type="button">
          <span className={style['icon']}>
            <LanguageIcon />
          </span>
          <span className={applyStyles([style['link'], 'text-h4'])}>{languages[currentLang] || languages.en}</span>
        </button>

        <button className={applyStyles([style['row'], 'text-h4'])} onClick={handleLogout} type="button">
          <span className={style['icon']}>
            <LogouotIcon />
          </span>
          <span className={applyStyles([style['link'], 'text-h4'])}>
            <FormattedMessage id="logout" />
          </span>
        </button>
      </section>
    </div>
  );
};

export default withRouter(OperationsMenuMobile);
